import { LocaleKeys } from "src/internationalization/CustomIntlProvider";
import { CaseAlertStatus } from "src/types/case";

export const CASE_ALERT_STATUS_LABELS: Record<CaseAlertStatus, LocaleKeys> = {
  initial: "page.case.caseAlertStatus.initial",
  scored: "page.case.caseAlertStatus.scored",
  compliant: "page.case.caseAlertStatus.compliant",
  fraudPrevented: "page.case.caseAlertStatus.fraudPrevented",
  pendingDecision: "page.case.caseAlertStatus.pendingDecision",
  provenFraudWithFinancialLoss: "page.case.caseAlertStatus.provenFraudWithFinancialLoss",
  provenFraudWithNoFinancialLoss: "page.case.caseAlertStatus.provenFraudWithNoFinancialLoss",
};
